export default "/fonts/ReverIcons.ttf?33ab0e458afb053b3ec9a2ffa0b6a6a7";